
/* Above-the-fold animation fix
   Triggers animations immediately for content already in viewport on page load */
(function() {
  function triggerAboveFoldAnimations() {
    // Find all elements that might need animation triggering
    var selectors = [
      '.pxs-image-with-text-wrapper',
      '.pxs-image-with-text-background',
      '.pxs-image-with-text-content-wrapper',
      '.rich-text-block',
      '.brand-catalogues--section',
      '.brand-catalogues--list',
      '.brand-row'
    ];

    selectors.forEach(function(selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function(el) {
        // Check if element is in viewport (above the fold)
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          // Force visibility
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          el.style.transform = 'none';

          // Also trigger any parent sections
          var section = el.closest('section');
          if (section) {
            section.style.opacity = '1';
            section.style.visibility = 'visible';
          }

          // Add ready attribute to trigger CSS animations
          var parent = el.closest('[data-section-id]');
          if (parent) {
            parent.setAttribute('ready', '');
          }
        }
      });
    });

    // Also set ready on body/main if needed
    var main = document.querySelector('.site-main');
    if (main) {
      main.setAttribute('ready', '');
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', triggerAboveFoldAnimations);
  } else {
    triggerAboveFoldAnimations();
  }

  // Also run after a short delay to catch any late-loading elements
  setTimeout(triggerAboveFoldAnimations, 100);
  setTimeout(triggerAboveFoldAnimations, 500);
})();
